import React, { Component } from 'react';
import { Card, Button, CardHeader, CardBody, Label, Table, Progress, Row, Col, FormGroup, Input, FormFeedback, Alert } from 'reactstrap';
import { FaPlusCircle } from 'react-icons/fa';
import FaTrash from "../../imgs/deleteIcon.png"
import FaPencilAlt from "../../imgs/lapiz.svg"
import MensajeModal from "../MensajeModal"
import { OBTENER_URL_SERVICIO } from "../../constants/action-types";
import axios from "axios";
import Timer from "react-time-counter";

class TablaModulos extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalEstado: false,
            modalTitulo: "",
            modalMensaje: "",
            modalFooter: "",
            datosTraidos: [],

            listaAreas: [],
            modalIDModulo: "",
            modalNombreModulo: "",
            modalIDArea: "",
            modalNombreArea: "",
            invalid2: false,
        };
        this.toggle = this.toggle.bind(this);
        this.modalNuevo = this.modalNuevo.bind(this);
        this.modalEditar = this.modalEditar.bind(this);
        this.modalEliminar = this.modalEliminar.bind(this);
        this.buscarDatos = this.buscarDatos.bind(this);
        this.borrarSeleccion = this.borrarSeleccion.bind(this);
        this.editarSeleccion = this.editarSeleccion.bind(this);
        this.agregarDato = this.agregarDato.bind(this);
        this.handleChangeModal = this.handleChangeModal.bind(this);
        this.handleSelectAux = this.handleSelectAux.bind(this);
    }

    toggle() {
        this.setState({
            modalEstado: !this.state.modalEstado
        });
    }

    async handleSelectAux(e) {
        await this.setState({
            modalNombreArea: e.target.selectedOptions[0].id,
            modalIDArea: e.target.selectedOptions[0].value
        })
    }

    async handleChangeModal(e) {
        const idVariable = e.target.name;
        var opcionesAreas = this.state.listaAreas.map(p => {
            return (<option key={p.seqArea} value={p.seqArea} id={p.namArea} name={p.namArea}>{p.namArea} </option>)
        });
        switch (idVariable) {
            case "modalNombreModulo":
                if (e.target.value.length <= 80) { // PASO DE 20 A 80
                    await this.setState({
                        modalNombreModulo: e.target.value
                    })
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Módulo</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreModulo} bsSize="sm" type="text" name="modalNombreModulo" id="modalNombreModulo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Área</Label>
                                            <Input defaultValue={this.state.modalIDArea} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                                {opcionesAreas}
                                            </Input>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                }
                break;
            default:
                break;
        }
    }

    async componentDidMount() {
        this.setState({
            modalTitulo: "Cargando",
            modalMensaje:
                <div>
                    <p>Estamos buscando los módulos existentes, ¡Por favor espera!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        this.toggle();
        await this.buscarDatos(true);
    }

    async buscarDatos(bool) {
        try {
            const response = await axios.get(OBTENER_URL_SERVICIO + "/modulos");
            //const response = { DataJson }
            await this.setState({
                datosTraidos: response.data
                //datosTraidos: response.DataJson
            })

            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/Allareas");
            await this.setState({
                listaAreas: response2.data
            })

            if (bool === true) {
                this.toggle();
            }
        }
        catch{
            await this.setState({
                datosTraidos: ""
            })

            if (bool === true) {
                this.toggle();
            }
        }
    }

    async modalNuevo() {
        var opcionesAreas = this.state.listaAreas.map(p => {
            return (<option key={p.seqArea} value={p.seqArea} id={p.namArea} name={p.namArea}>{p.namArea} </option>)
        });
        await this.setState({
            auxID: 999,
            invalid2: false,
            modalIDModulo: "",
            modalNombreModulo: "",
            modalIDArea: this.state.listaAreas[0].seqArea,
            modalNombreArea: this.state.listaAreas[0].namArea,
        })

        this.setState({
            invalid2: false,
            modalIDModulo: "",
            modalNombreModulo: "",
            modalIDArea: this.state.listaAreas[0].seqArea,
            modalNombreArea: this.state.listaAreas[0].namArea,
            modalTitulo: "Agregar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Módulo</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreModulo} bsSize="sm" type="text" name="modalNombreModulo" id="modalNombreModulo" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Área</Label>
                                <Input defaultValue={this.state.modalIDArea} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                    {opcionesAreas}
                                </Input>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.agregarDato} color="success">Agregar</Button>
            </div>
        })
        this.toggle();
    }
    async agregarDato() {
        var hayError = false;
        if (this.state.modalNombreModulo === undefined || this.state.modalNombreModulo === "" || this.state.modalNombreModulo === null || this.state.modalNombreModulo.length < 2 || this.state.modalNombreModulo.length >= 81) { // PASO DE 21 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (hayError === true) {
            var opcionesAreas = this.state.listaAreas.map(p => {
                return (<option key={p.seqArea} value={p.seqArea} id={p.namArea} name={p.namArea}>{p.namArea} </option>)
            });
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Módulo</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreModulo} bsSize="sm" type="text" name="modalNombreModulo" id="modalNombreModulo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Área</Label>
                                            <Input defaultValue={this.state.modalIDArea} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                                {opcionesAreas}
                                            </Input>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                secModulo: this.state.modalIDModulo,
                namModulo: this.state.modalNombreModulo,
                secArea: this.state.modalIDArea,
            }
            try {
                const response = await axios.post(OBTENER_URL_SERVICIO + "/modulo/new", envioDatos);
                if (response.data.tipo === "EXITO") {
                    this.setState({
                        modalTitulo: "Exito",
                        modalMensaje:
                            <div>
                                <p>¡Dato agregado!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "ERROR") {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                const response2 = await axios.get(OBTENER_URL_SERVICIO + "/Allareas");
                await this.setState({
                    listaAreas: response2.data
                })
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    async modalEditar(event) {
        var opcionesAreas = this.state.listaAreas.map(p => {
            return (<option key={p.seqArea} value={p.seqArea} id={p.namArea} name={p.namArea}>{p.namArea} </option>)
        });
        const datos = event.target.id;
        const arrayDatos = datos.split("///");
        await this.setState({
            auxID: arrayDatos[0],
            modalIDModulo: arrayDatos[0],
            modalNombreModulo: arrayDatos[1],
            modalIDArea: arrayDatos[2],
            modalNombreArea: arrayDatos[3]
        })
        this.setState({
            invalid2: false,
            modalTitulo: "Editar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>Por favor ingresa los datos a modificar:</Label>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Nombre Módulo</Label>
                                <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreModulo} bsSize="sm" type="text" name="modalNombreModulo" id="modalNombreModulo" onChange={this.handleChangeModal} />
                                <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                            </FormGroup>
                        </center>
                    </Col>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                        <center>
                            <FormGroup>
                                <Label for="exampleEmail">Área</Label>
                                <Input defaultValue={this.state.modalIDArea} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                    {opcionesAreas}
                                </Input>
                            </FormGroup>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button onClick={this.editarSeleccion} color="warning">Editar</Button>
            </div>
        })
        this.toggle();
    }
    async editarSeleccion() {
        var hayError = false;
        if (this.state.modalNombreModulo === undefined || this.state.modalNombreModulo === "" || this.state.modalNombreModulo === null || this.state.modalNombreModulo.length < 1 || this.state.modalNombreModulo.length >= 81) { // PASO DE 33 A 81
            hayError = true;
            this.setState({
                invalid2: true,
            })
        } else {
            this.setState({
                invalid2: false,
            })
        }
        if (hayError === true) {
            var opcionesAreas = this.state.listaAreas.map(p => {
                return (<option key={p.seqArea} value={p.seqArea} id={p.namArea} name={p.namArea}>{p.namArea} </option>)
            });
            setTimeout(
                function () {
                    this.setState({
                        modalMensaje:
                            <Row>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                                    <center>
                                        <Label>Por favor ingresa los datos a modificar:</Label>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Nombre Módulo</Label>
                                            <Input invalid={this.state.invalid2} style={{ marginTop: "-12px", marginBottom: "7px" }} value={this.state.modalNombreModulo} bsSize="sm" type="text" name="modalNombreModulo" id="modalNombreModulo" onChange={this.handleChangeModal} />
                                            <FormFeedback tooltip>De 2 a 80 Caracteres</FormFeedback>
                                        </FormGroup>
                                    </center>
                                </Col>
                                <Col xs={{ size: 12 }} sm={{ size: 12 }} md={{ size: 12 }} lg={{ size: 6 }}>
                                    <center>
                                        <FormGroup>
                                            <Label for="exampleEmail">Área</Label>
                                            <Input defaultValue={this.state.modalIDArea} onChange={this.handleSelectAux} style={{ marginTop: "-12px", marginBottom: "7px" }} bsSize="sm" type="select" name="selectRol" id="selectRol">
                                                {opcionesAreas}
                                            </Input>
                                        </FormGroup>
                                    </center>
                                </Col>
                            </Row>,
                    })
                    return null;
                }
                    .bind(this),
                10
            );
        } else {
            this.setState({
                modalTitulo: "Procesando",
                modalMensaje:
                    <div>
                        <p>¡Estamos procesando la acción, espera por favor!</p>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <Progress animated color="success" value="100" />
                </div>
            })
            var envioDatos = {
                secModulo: this.state.modalIDModulo,
                namModulo: this.state.modalNombreModulo,
                secArea: this.state.modalIDArea,
            }
            try {
                const response = await axios.put(OBTENER_URL_SERVICIO + "/modulo/" + this.state.auxID, envioDatos);
                if (response.data.tipo === "Actualizado") {
                    this.setState({
                        modalTitulo: "Actualizado",
                        modalMensaje:
                            <div>
                                <p>¡Módulo actualizado con éxito!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    if (response.data.tipo === "Error") {
                        this.setState({
                            modalTitulo: "Módulo no encontrada",
                            modalMensaje:
                                <div>
                                    <p>No se encontró el cliente para eliminar.</p>
                                    <p>¡Quizás alguien se adelantó!</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    } else {
                        this.setState({
                            modalTitulo: "Error",
                            modalMensaje:
                                <div>
                                    <p>No se puede procesar la acción, intenta de nuevo más tarde.</p>
                                </div>,
                            modalFooter: <div>
                                <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                            </div>
                        })
                    }
                }
                this.buscarDatos(false)
            }
            catch (error) {
                const response2 = await axios.get(OBTENER_URL_SERVICIO + "/Allareas");
                await this.setState({
                    listaAreas: response2.data
                })
                this.setState({
                    modalTitulo: "Error",
                    modalMensaje:
                        <div>
                            <center>
                                <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                            </center>
                        </div>,
                    modalFooter: <div style={{ width: "100%" }}>
                        <center>
                            <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                        </center>
                    </div>,
                })
                setTimeout(
                    function () {
                        this.toggle();
                    }
                        .bind(this),
                    5000
                );
            }
        }
    }

    modalEliminar(event) {
        this.setState({
            modalTitulo: "Eliminar",
            modalMensaje:
                <Row>
                    <Col xs={{ size: 12 }} sm={{ size: 12 }} >
                        <center>
                            <Label>¡ATENCIÓN!</Label>
                            <br />
                            <Label>Se eliminará el dato seleccionado.</Label>
                        </center>
                    </Col>
                </Row>,
            modalFooter: <div>
                <Button color="secondary" onClick={this.toggle}>Cancelar</Button>{' '}
                <Button id={event.target.id} onClick={this.borrarSeleccion} color="danger">Eliminar</Button>
            </div>
        })
        this.toggle();
    }
    async borrarSeleccion(event) {
        this.setState({
            modalTitulo: "Procesando",
            modalMensaje:
                <div>
                    <p>¡Estamos procesando la acción, espera por favor!</p>
                </div>,
            modalFooter: <div style={{ width: "100%" }}>
                <Progress animated color="success" value="100" />
            </div>
        })
        try {
            const response = await axios.delete(OBTENER_URL_SERVICIO + "/modulo/" + event.target.id);
            if (response.data.tipo === "EXITO") {
                this.setState({
                    modalTitulo: "EXITO",
                    modalMensaje:
                        <div>
                            <p>¡Cliente eliminado con éxito!</p>
                        </div>,
                    modalFooter: <div>
                        <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                    </div>
                })
            } else {
                if (response.data.tipo === "NO ENCONTRADO") {
                    this.setState({
                        modalTitulo: "Módulo no encontrada",
                        modalMensaje:
                            <div>
                                <p>No se encontró el área para eliminar.</p>
                                <p>¡Quizás alguien se adelantó!</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                } else {
                    this.setState({
                        modalTitulo: "Error",
                        modalMensaje:
                            <div>
                                <p>Por favor, valida que el módulo no contenga agentes.</p>
                            </div>,
                        modalFooter: <div>
                            <Button color="secondary" onClick={this.toggle}>Aceptar</Button>
                        </div>
                    })
                }
            }
            this.buscarDatos(false)
        }
        catch (error) {
            const response2 = await axios.get(OBTENER_URL_SERVICIO + "/Allareas");
            await this.setState({
                listaAreas: response2.data
            })
            this.setState({
                modalTitulo: "Error",
                modalMensaje:
                    <div>
                        <center>
                            <p>Tu solicitud no puede ser enviada ahora mismo. Por favor intenta más tarde. (500 Error)</p>
                        </center>
                    </div>,
                modalFooter: <div style={{ width: "100%" }}>
                    <center>
                        <Label><Timer seconds={5} backward={true} id="timerTiempoModalX" label={<span></span>} /></Label>
                    </center>
                </div>,
            })
            setTimeout(
                function () {
                    this.toggle();
                }
                    .bind(this),
                5000
            );
        }

    }

    render() {

        var datosTabla =
            <Alert color="primary">
                No hay Módulos inscritos.
</Alert>

        if (this.state.datosTraidos !== null && this.state.datosTraidos !== undefined && this.state.datosTraidos.length > 0) {
            datosTabla =
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>ID Módulo</th>
                            <th>Nombre Módulo</th>
                            <th>ID Área</th>
                            <th>Nombre Área</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.datosTraidos.map(p => {
                            return (
                                <tr key={p[0]}>
                                    <th scope="row">{p[0]}</th>
                                    <td>{p[1]}</td>
                                    <td>{p[2]}</td>
                                    <td>{p[3]}</td>
                                    <td><Button size="sm" color="warning" id={p[0] + "///" + p[1] + "///" + p[2] + "///" + p[3]} onClick={this.modalEditar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaPencilAlt} id={p[0] + "///" + p[1] + "///" + p[2] + "///" + p[3]} alt="editar" /></Button>{" | | "}<Button size="sm" color="danger" id={p[0]} onClick={this.modalEliminar} ><img style={{ verticalAlign: "middle" }} height="15" src={FaTrash} id={p[0]} alt="borrar" /></Button></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
        }

        return (
            <div>
                <MensajeModal modal={this.state.modalEstado} titulo={this.state.modalTitulo} toggle={this.toggle} mensaje={this.state.modalMensaje} footer={this.state.modalFooter} ></MensajeModal>
                <CardBody>
                    <Card>
                        <CardHeader style={{ backgroundColor: "#c0d6e4" }}> <Label style={{ color: "black", fontSize: "25px" }}>Gestionar Módulos </Label> <Button className="btn btn-success float-right" onClick={this.modalNuevo}><FaPlusCircle></FaPlusCircle> Agregar Módulos</Button></CardHeader>
                        <CardBody>
                            {datosTabla}
                        </CardBody>
                    </Card>
                </CardBody>
            </div>
        );
    }
}

export default TablaModulos;